<template>
  <div>
    <div class="row">
      <div class="col-12">
        <MultipleCollectionSelection
          v-show="selectedService"
          class="pb-4 pb-lg-0"
          :maximumCollectionCount="selectedServiceId"
          :selectedService="selectedService"
          @update="
            (multipleCollection) =>
              updateServiceCart(selectedServiceId, multipleCollection)
          "
          @resetCalendar="resetCalendar"
          ref="multipleCollectionSelection"
        />
      </div>
    </div>
    <div class="row mb-4">
      <div class="col-12">
        <div class="pb-4 pb-lg-0">
          <WasteStreamSelection
            :selectedService="selectedService"
            @update="
              (wasteStreams) =>
                updateServiceCart(selectedServiceId, {
                  wasteStreams,
                })
            "
            @removeDependentWasteStream="removeDependentWasteStream"
            :removeProduct="pluckProduct"
            :selectedServiceCart="selectedServiceCart"
            ref="wasteStreamSelection"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MultipleCollectionSelection from "./MultipleCollectionSelection";
import WasteStreamSelection from "./WasteStreamSelection";
import Helper from "../../../../helper";

export default {
  components: {
    MultipleCollectionSelection,
    WasteStreamSelection,
  },
  props: {
    selectedService: Object,
  },
  data() {
    return {
      serviceCarts: [],
      selectedServicePrice: null,
      multipleWasteCollectionEnabled: false,
      wasteComboList: null,
      priceSettings: [],
      pluckProduct: null,
    };
  },
  watch: {
    selectedService(newValue) {
      this.loadCartState(this.selectedServiceCart, newValue);
      this.selectedServicePrice = this.determineServicePrice();
    },
  },
  computed: {
    selectedServiceCart() {
      var selectedServiceId = this.selectedServiceId
      if (!selectedServiceId) {
        return null;
      }

      var foundCart = this.serviceCarts.find(
        (serviceCart) => serviceCart.serviceId == selectedServiceId
      );

      return foundCart;
    },
    selectedServiceId() {
      return this.selectedService
        ? this.selectedService.service_setting_id
        : null;
    },
    allWasteStreamCombos() {
      return this.$store.getters.GET_WASTE_COMBO_LIST.list;
    },
    selectedMultipleCollectionSetting() {
      return this.$refs.multipleCollectionSelection &&
        this.$refs.multipleCollectionSelection.multipleCollectionSetting
        ? this.$refs.multipleCollectionSelection.multipleCollectionSetting
        : null;
    },
  },
  mounted() {
    this.$store.dispatch(`getServicePriceSettings`).then((result) => {
      this.priceSettings = result;
      this.$emit("priceSettingsLoaded", result);
    });
    this.$store.dispatch("getWasteComboList").then((result) => {
      // --- Format the Result
      var list = Array.isArray(result.list) ? result.list : [];
      list = list.map((combo) => {
        return {
          serviceId: combo.service_setting_id,
          comboApi: combo.api_value,
          primaryId: combo.primary_waste_stream ? combo.primary_waste_stream.waste_stream_setting_id : null,
          secondaryId: combo.secondary_waste_stream ? combo.secondary_waste_stream.waste_stream_setting_id : null,
        };
      });
      this.wasteComboList = list;
    });
  },
  methods: {
    updateServiceCart(serviceId, updateObject) {
      // --- Identify the service cart to be updated
      var findIndex = this.serviceCarts.findIndex(
        (serviceCart) => serviceCart.serviceId == serviceId
      );
      if (findIndex == -1) {
        this.serviceCarts.push({
          serviceId,
        });
        findIndex = this.serviceCarts.length - 1;
      }

      // --- Determine if that cart will be changed by the updateObject
      var hasChanged = false;
      for (var key in updateObject) {
        if (
          !this.serviceCarts[findIndex][key] ||
          this.serviceCarts[findIndex][key] != updateObject[key]
        ) {
          hasChanged = true;

          // --- Object Update
          if (
            typeof this.serviceCarts[findIndex][key] == "object" &&
            typeof updateObject[key] == "object"
          ) {
            for (var subKey in updateObject[key]) {
              this.serviceCarts[findIndex][key][subKey] =
                updateObject[key][subKey];
            }
          } else {
            this.serviceCarts[findIndex][key] = updateObject[key];
          }
        }
      }

      if (hasChanged) {
        // --- Update Booking Products
        var bookingProducts = [];

        if (
          this.serviceCarts[findIndex] &&
          typeof this.serviceCarts[findIndex].wasteStreams != null &&
          typeof this.serviceCarts[findIndex].wasteStreams == "object"
        ) {
          var filteredWasteStreams = {};

          /*
            Stry: P2US409_BUG03
            Date: 2020-11-05
            Auth: Franco Mapua
            Desc: Removing empty waste streams in this.serviceCarts[findIndex].wasteStreams 
          */
          for (var optionId in this.serviceCarts[findIndex].wasteStreams) {
            if (
              this.serviceCarts[findIndex].wasteStreams[optionId] &&
              !isNaN(this.serviceCarts[findIndex].wasteStreams[optionId].qty) &&
              this.serviceCarts[findIndex].wasteStreams[optionId].qty != 0
            ) {
              filteredWasteStreams[optionId] = this.serviceCarts[
                findIndex
              ].wasteStreams[optionId];
            }
          }

          /*
            Stry: DEF_RP2_TEST2: Hardwastes available dates are not enabling: PAE/ADE/The hills
            Date: 2020-11-27
            Auth: Franco Mapua
            Desc: Applying Waste Combo Logic
          */
          if (
            Array.isArray(this.wasteComboList) &&
            this.wasteComboList.length > 0
          ) {
            this.wasteComboList.forEach((combo) => {
              // -- Check Level 1 Waste Streams for combos
              if (
                combo.serviceId == serviceId &&
                filteredWasteStreams[combo.primaryId] &&
                filteredWasteStreams[combo.secondaryId]
              ) {
                filteredWasteStreams[combo.primaryId].apiValue =
                  filteredWasteStreams[combo.primaryId].wasteComboApiValue;
              }
            });
          }

          // --- Update the filtered Waste Streams
          this.serviceCarts[findIndex].wasteStreams = filteredWasteStreams;
        }

        // --- Assemble selected Waste Streams
        var selectedWasteStreams =
          this.serviceCarts[findIndex].wasteStreams || [];

        var bookingProductsExists = false;
        for (var optionId in selectedWasteStreams) {
          if (selectedWasteStreams[optionId]) {
            bookingProducts.push(selectedWasteStreams[optionId]);
            if (selectedWasteStreams[optionId].qty > 0) {
              bookingProductsExists = true;
            }
          }
        }

        // --- If there are Waste Streams and the service has a price, push it
        if (bookingProductsExists && this.selectedServicePrice) {
          bookingProducts = [
            {
              qty: 1,
              isService: true,
              price: this.selectedServicePrice,
              name: this.selectedService.service_name,
            },
            ...bookingProducts,
          ];
        }

        // --- Determine Waste Display Values
        var {
          multipleCollectionCount,
          displayMultipleCollection,
          displayStreamQuantities,
        } = updateObject;

        var bookingStateUpdateObj = {
          selectedBookingProducts: bookingProducts,
        };
        if (multipleCollectionCount != undefined) {
          bookingStateUpdateObj.multipleCollectionCount = multipleCollectionCount;
          this.$store.dispatch("setActiveMultipleServiceOtherBookingState", {
            multipleCollectionCount,
          });
        }
        if (displayMultipleCollection != undefined) {
          bookingStateUpdateObj.displayMultipleCollection = displayMultipleCollection;
          this.$store.dispatch("setActiveMultipleServiceOtherBookingState", {
            displayMultipleCollection,
          });
        }
        if (displayStreamQuantities != undefined) {
          bookingStateUpdateObj.displayStreamQuantities = displayStreamQuantities;
          this.$store.dispatch("setActiveMultipleServiceOtherBookingState", {
            displayStreamQuantities,
          });
        }

        this.$store.dispatch("setBookingProducts", bookingProducts);
        this.$store.dispatch("setBookingState", bookingStateUpdateObj);

        // --- Get computed entitlement
        var isCollectionPerWasteQty =
          this.selectedMultipleCollectionSetting &&
          this.selectedMultipleCollectionSetting.selection == 2;
        if (isCollectionPerWasteQty) {
          var formattedWasteStreams = [];

          var wasteStreamHash = {};

          bookingProducts.forEach((product) => {
            var wasteStreamId = product.waste_stream_setting_id;
            if (wasteStreamId) {
              if (!wasteStreamHash[wasteStreamId]) {
                wasteStreamHash[wasteStreamId] = {
                  wasteStreamDesc:
                    this.selectedService.api_value + "-" + product.apiValue,
                  estimatedQuantity1: 0,
                  estimatedQuantity2: 0,
                };
              }
              var qty = product.qty || 0;
              if (qty > 0) {
                wasteStreamHash[wasteStreamId].estimatedQuantity1 =
                  wasteStreamHash[wasteStreamId].estimatedQuantity1 + qty;
              }
              if (product.siteForMultiCollection) {
                wasteStreamHash[wasteStreamId].estimatedQuantity1 =
                  product.siteForMultiCollection;
              }
            }
          });

          // --- Waste Stream Desc to products

          // --- Convert the wasteStreamHash into an array
          var payloadWasteStreams = [];
          for (var optionId in wasteStreamHash) {
            payloadWasteStreams.push(wasteStreamHash[optionId]);
          }

          // --- Determine if ComputeEntitlements should be sent
          var isComputeEntitlementsEnabled = false;
          if (
            payloadWasteStreams.length <= 0 ||
            this.selectedMultipleCollectionSetting.selection != 2
          ) {
            isComputeEntitlementsEnabled = false;
          } else if (this.selectedService.is_paid == Helper.Payment.Paid) {
            isComputeEntitlementsEnabled =
              this.selectedMultipleCollectionSetting.per_waste_paid == 1;
          } else if (this.selectedService.is_paid == Helper.Payment.Free) {
            isComputeEntitlementsEnabled =
              this.selectedMultipleCollectionSetting.per_waste_summary == 1;
          }
          if (isComputeEntitlementsEnabled) {
            var self = this;

            // --- Reset compute entitelmetn
            self.$store.dispatch("setBookingState", {
              computedEntitlement: -1,
            });
            this.$store
              .dispatch("getComputedEntitlements", {
                wasteStreams: { wasteStreams: payloadWasteStreams },
              })
              .then((result) => {
                // --- Check if Results has wasteStreams

                var estimatedEntitlements =
                  result && typeof result.estimatedEntitlements == "object"
                    ? result.estimatedEntitlements
                    : null;
                var computedEntitlement =
                  Array.isArray(estimatedEntitlements) &&
                  estimatedEntitlements.length > 0
                    ? estimatedEntitlements[0].estimatedEntitlement
                    : null;

                if (
                  computedEntitlement !== null ||
                  computedEntitlement !== undefined
                ) {
                  self.$store.dispatch("setBookingState", {
                    computedEntitlement,
                  });
                  self.$store.dispatch(
                    "setActiveMultipleServiceOtherBookingState",
                    { computedEntitlement }
                  );
                }
              });
          }
        }
      }
    },
    loadCartState(serviceCartState = {}, serviceData) {
      if (!serviceCartState) {
        serviceCartState = {};
      }

      // --- Append Service information
      serviceCartState.service = serviceData;

      // --- Multiple Collection
      if (serviceCartState && this.$refs.multipleCollectionSelection) {
        this.$refs.multipleCollectionSelection.loadMultipleCollectionState(
          serviceCartState
        );
      }
      // --- Waste Streams
      if (serviceCartState && this.$refs.wasteStreamSelection) {
        this.$refs.wasteStreamSelection.loadWasteStreamState(serviceCartState);
      }

      // --- Reset serviceCartState
      this.serviceCarts = [];
    },
    printDebug() {
      document.getElementById("logoutput").innerHTML = JSON.stringify(
        this.serviceCarts
      );
    },
    setMultipleCollection(multipleCollectionCount) {
      this.$refs.multipleCollectionSelection.selected = multipleCollectionCount;
      var selectedServiceId = this.selectedServiceId
      this.updateServiceCart(selectedServiceId, {
        multipleCollectionCount: multipleCollectionCount,
      });
    },
    determineServicePrice() {
      var selectedService = this.selectedService;

      if (
        !selectedService ||
        this.selectedService.is_paid == Helper.Payment.Free ||
        !this.priceSettings
      )
        return null;

      let servicePricing = this.priceSettings.find((pricing) => {
        return (
          pricing &&
          pricing.service_setting_id == this.selectedServiceId &&
          pricing.price
        );
      });
      if (
        servicePricing &&
        servicePricing.price &&
        !isNaN(servicePricing.price)
      ) {
        var price = parseFloat(servicePricing.price);
        return price;
      }
    },
    resetCalendar() {
      
    },
    pluckProductFromSelection(product) {
      this.pluckProduct = product;
    },
    /**
    * Story:  RP-128
    * Author: Joseph
    * Desc:   In Brim, when a waste is selected and has dependency that waste wouldn't be selected BUT still added to cart.
    *         By the time you select any waste without waste dependency the calendar wont enable (it should) bcoz a faulty
    *         waste is added to cart with -1 quantity (the waste with dependency).
    *         Fix is to remove the waste from cart once propmted to have waste dependency
    */
    removeDependentWasteStream(optionIds)
      {
      const findIndex = this.serviceCarts.findIndex(serviceCart => serviceCart.serviceId == this.selectedServiceId);

      if (findIndex > -1)
        {
        // converts from object into array
        // output: [ [prop, val], ... ]
        const streams = Object.entries(this.serviceCarts[findIndex].wasteStreams)

        // filter prop to not equal to any provided optionIds[]
        // output: filtered [ [porp, val], ... ]
        const filteredWastesEntries = streams.filter(([option_id, val]) => optionIds.indexOf(option_id) < 0 );

        // converts from array into object again
        // output: { prop1: val, prop2: val, ... }
        this.serviceCarts[findIndex].wasteStreams = Object.fromEntries(filteredWastesEntries);
        }
      }
  },
};
</script>

<style lang="scss" scoped>
</style>